import { useQuery } from '@tanstack/react-query'
import { ACTIVE_POLICY_DOCUMENTS_KEY, POLICY_CONSENT_STATUS_KEY } from 'common/constants/queryKeys'

import { getActivePolicyDocuments, getPolicyConsentStatus } from '.'
import { ActivePolicyDocument, ConsentStatusResponse } from './types'

export const useGetPolicyConsentStatus = (enabled = true) => {
  return useQuery<ConsentStatusResponse>({
    queryKey: POLICY_CONSENT_STATUS_KEY,
    queryFn: async () => {
      const { data } = await getPolicyConsentStatus()
      return data.data
    },
    // Gated by the POLICY_CONSENT feature flag: no request when disabled.
    enabled,
    staleTime: 5 * 60 * 1000,
    // Always re-check on guard mount so a consent given elsewhere (or a new
    // document version) is picked up; cached data still renders instantly.
    refetchOnMount: 'always',
  })
}

export const useGetActivePolicyDocuments = () => {
  return useQuery<ActivePolicyDocument[]>({
    queryKey: ACTIVE_POLICY_DOCUMENTS_KEY,
    queryFn: async () => {
      const { data } = await getActivePolicyDocuments()
      return data.data
    },
    staleTime: 5 * 60 * 1000,
  })
}
